// Pinterest i18n fragment
const fragment = {
  vi: {
    // pinterestAccount (list)
    'pin.pinterestAccount.title': 'Tài khoản Pinterest',
    'pin.pinterestAccount.add': 'Thêm',
    'pin.pinterestAccount.searchLabel': 'Tìm kiếm tài khoản',
    'pin.pinterestAccount.search': 'Tìm kiếm',
    'pin.pinterestAccount.reset': 'Đặt lại',

    // common
    'pin.common.needReconnect': 'Cần kết nối lại',
    'pin.common.paused': 'Tạm tắt',

    // pinterestDetail
    'pin.pinterestDetail.back': 'Quay lại',
    'pin.pinterestDetail.badge.disabled': 'Tạm tắt',
    'pin.pinterestDetail.openPinterest': 'Mở Pinterest.com',
    'pin.pinterestDetail.edit': 'Chỉnh sửa',
    'pin.pinterestDetail.reconnect': 'Kết nối lại',
    'pin.pinterestDetail.createPin': 'Tạo Pin',
    'pin.pinterestDetail.stat.followers': 'Người theo dõi',
    'pin.pinterestDetail.stat.following': 'Đang theo dõi',
    'pin.pinterestDetail.stat.pins': 'Pin',
    'pin.pinterestDetail.stat.boards': 'Bảng',
    'pin.pinterestDetail.stat.monthlyViews': 'Lượt xem / tháng',
    'pin.pinterestDetail.tab.boards': 'Bảng ({count})',
    'pin.pinterestDetail.tab.pins': 'Bài viết',
    'pin.pinterestDetail.boards.hint':
      'Quản lý các bảng (board) của tài khoản. Click vào một board để xem pin trong đó.',
    'pin.pinterestDetail.boards.create': 'Tạo board',
    'pin.pinterestDetail.boards.empty.title': 'Chưa có board nào',
    'pin.pinterestDetail.boards.empty.desc': 'Bấm "Tạo board" phía trên để tạo bảng đầu tiên.',
    'pin.pinterestDetail.pins.filterByBoard': 'Lọc theo bảng:',
    'pin.pinterestDetail.pins.clearFilter': 'Bỏ lọc',
    'pin.pinterestDetail.pins.empty.title': 'Chưa có pin nào',
    'pin.pinterestDetail.pins.empty.desc': 'Bắt đầu tạo pin đầu tiên cho tài khoản này.',
    'pin.pinterestDetail.pins.empty.boardTitle': 'Board "{name}" chưa có pin',
    'pin.pinterestDetail.pins.empty.boardDesc': 'Hãy tạo pin đầu tiên cho board này.',
    'pin.pinterestDetail.pins.loadMore': 'Tải thêm pin',
    'pin.pinterestDetail.pins.allShown': 'Đã hiển thị toàn bộ {count} pin',
    'pin.pinterestDetail.toast.loadPinsError': 'Tải danh sách pin thất bại.',

    // boardCard
    'pin.boardCard.privacy.public': 'Công khai',
    'pin.boardCard.privacy.protected': 'Bảo vệ',
    'pin.boardCard.privacy.secret': 'Riêng tư',
    'pin.boardCard.noCover': 'Chưa có ảnh bìa',
    'pin.boardCard.untitled': 'Board chưa đặt tên',
    'pin.boardCard.pinCount': '{count} pin',
    'pin.boardCard.followerCount': '{count} người theo dõi',

    // createBoardModal
    'pin.createBoardModal.title': 'Tạo board Pinterest',
    'pin.createBoardModal.field.name': 'Tên board',
    'pin.createBoardModal.field.description': 'Mô tả',
    'pin.createBoardModal.field.privacy': 'Quyền riêng tư',
    'pin.createBoardModal.privacy.public': 'Công khai (PUBLIC)',
    'pin.createBoardModal.privacy.protected': 'Bảo vệ (PROTECTED)',
    'pin.createBoardModal.privacy.secret': 'Riêng tư (SECRET)',
    'pin.createBoardModal.cancel': 'Hủy',
    'pin.createBoardModal.create': 'Tạo',
    'pin.createBoardModal.toast.nameRequired': 'Vui lòng nhập tên board.',
    'pin.createBoardModal.toast.createSuccess': 'Tạo board thành công.',
    'pin.createBoardModal.toast.createError': 'Tạo board thất bại.',

    // pinCard
    'pin.pinCard.noImage': 'Không có ảnh',

    // pinLightbox
    'pin.pinLightbox.attachedLink': 'Link đính kèm',
    'pin.pinLightbox.altText': 'Mô tả ảnh (alt text)',
    'pin.pinLightbox.openOnPinterest': 'Mở trên Pinterest.com',

    // pinterestForm
    'pin.pinterestForm.title.create': 'Tạo tài khoản Pinterest',
    'pin.pinterestForm.title.update': 'Cập nhật tài khoản Pinterest',
    'pin.pinterestForm.login': 'Đăng nhập Pinterest',
    'pin.pinterestForm.loginAgain': 'Đăng nhập lại Pinterest',
    'pin.pinterestForm.linkedAccount': 'Đã liên kết tài khoản Pinterest',
    'pin.pinterestForm.create': 'Tạo',
    'pin.pinterestForm.update': 'Cập nhật',
    'pin.pinterestForm.cancel': 'Hủy',
    'pin.pinterestForm.field.name': 'Tên gợi nhớ',
    'pin.pinterestForm.field.username': 'Tên người dùng',
    'pin.pinterestForm.field.businessName': 'Tên doanh nghiệp',
    'pin.pinterestForm.field.userId': 'User ID',
    'pin.pinterestForm.field.website': 'Website',
    'pin.pinterestForm.field.active': 'Kích hoạt',
    'pin.pinterestForm.field.namePlaceholder': 'VD: Pinterest Shop chính',
    'pin.pinterestForm.field.nameHint':
      'Tên nội bộ để bạn dễ nhận ra tài khoản này — không hiển thị trên Pinterest.',
    'pin.pinterestForm.connect.heading': 'Kết nối tài khoản Pinterest',
    'pin.pinterestForm.connect.desc':
      'Đăng nhập Pinterest để cấp quyền cho hệ thống đăng Pin và quản lý board thay bạn. Mật khẩu của bạn không được lưu; chúng tôi chỉ nhận mã uỷ quyền an toàn.',
    'pin.pinterestForm.scope.title': 'Kiểm tra quyền truy cập',
    'pin.pinterestForm.scope.desc':
      'Xem hệ thống đang có những quyền nào trên tài khoản Pinterest này.',
    'pin.pinterestForm.scope.check': 'Kiểm tra ngay',
    'pin.pinterestForm.scope.granted': 'Đã cấp',
    'pin.pinterestForm.scope.missing': 'Chưa cấp',
    'pin.pinterestForm.scope.perm.userRead': 'Đọc thông tin tài khoản',
    'pin.pinterestForm.scope.perm.boardsRead': 'Xem danh sách board',
    'pin.pinterestForm.scope.perm.boardsWrite': 'Tạo & sửa board',
    'pin.pinterestForm.scope.perm.pinsRead': 'Xem Pin',
    'pin.pinterestForm.scope.perm.pinsWrite': 'Tạo Pin',
    'pin.pinterestForm.scope.perm.other': 'Quyền khác',
    'pin.pinterestForm.scope.missingBoardsWrite':
      'Chưa có quyền "Tạo & sửa board". Bấm "Đăng nhập lại Pinterest" để cấp lại quyền.',
    'pin.pinterestForm.scope.missingPinsWrite':
      'Chưa có quyền "Tạo Pin". Bấm "Đăng nhập lại Pinterest" để cấp lại quyền.',
    'pin.pinterestForm.toast.loginDenied': 'Pinterest từ chối đăng nhập: {reason}',
    'pin.pinterestForm.toast.invalidState': 'State OAuth không hợp lệ, vui lòng đăng nhập lại.',
    'pin.pinterestForm.toast.fetchError': 'Lấy thông tin Pinterest thất bại',
    'pin.pinterestForm.toast.missingClientId': 'Thiếu cấu hình REACT_APP_PINTEREST_CLIENT_ID.',
    'pin.pinterestForm.toast.needLogin': 'Bạn cần đăng nhập Pinterest trước khi tạo tài khoản.',
    'pin.pinterestForm.toast.createSuccess': 'Tạo tài khoản thành công.',
    'pin.pinterestForm.toast.createError': 'Tạo tài khoản thất bại.',
    'pin.pinterestForm.toast.updateSuccess': 'Cập nhật tài khoản thành công.',
    'pin.pinterestForm.toast.updateError': 'Cập nhật tài khoản thất bại.',
    'pin.pinterestForm.toast.checkScopeError': 'Kiểm tra scope thất bại.',


    // table
    'pin.table.col.account': 'Tên tài khoản',
    'pin.table.col.followers': 'Lượt theo dõi',
    'pin.table.col.posts': 'Số bài viết',
    'pin.table.col.url': 'Đường dẫn',
    'pin.table.col.status': 'Trạng thái',
    'pin.table.col.createdAt': 'Ngày tạo',
    'pin.table.col.actions': 'Thao tác',
    'pin.table.copyUrl': 'Sao chép đường dẫn',
    'pin.table.tooltip.viewDetail': 'Xem chi tiết (boards, pins)',
    'pin.table.tooltip.viewDetailShort': 'Xem chi tiết',
    'pin.table.tooltip.createPin': 'Tạo bài Pin',
    'pin.table.tooltip.edit': 'Cập nhật tài khoản',
    'pin.table.tooltip.delete': 'Xóa tài khoản',
    'pin.table.tooltip.toggleStatus': 'Bật/tắt tài khoản',
    'pin.table.reconnectHint': 'Phiên đã hết hạn — bấm để kết nối lại',
    'pin.table.delete.title': 'Xoá tài khoản Pinterest?',
    'pin.table.delete.desc': 'Hành động này không thể hoàn tác.',
    'pin.table.delete.confirm': 'Xoá',
    'pin.table.empty.title': 'Chưa có tài khoản Pinterest',
    'pin.table.empty.desc': 'Kết nối tài khoản Pinterest đầu tiên để bắt đầu đăng Pin.',
    'pin.table.empty.action': 'Kết nối tài khoản',
    'pin.table.toast.statusChanged': 'Đã thay đổi trạng thái tài khoản',
    'pin.table.toast.statusError': 'Thay đổi trạng thái tài khoản thất bại',
    'pin.table.toast.deleteSuccess': 'Xóa tài khoản thành công',
  },
  en: {
    // pinterestAccount (list)
    'pin.pinterestAccount.title': 'Pinterest accounts',
    'pin.pinterestAccount.add': 'Add',
    'pin.pinterestAccount.searchLabel': 'Search accounts',
    'pin.pinterestAccount.search': 'Search',
    'pin.pinterestAccount.reset': 'Reset',

    // common
    'pin.common.needReconnect': 'Needs reconnect',
    'pin.common.paused': 'Paused',

    // pinterestDetail
    'pin.pinterestDetail.back': 'Back',
    'pin.pinterestDetail.badge.disabled': 'Disabled',
    'pin.pinterestDetail.openPinterest': 'Open Pinterest.com',
    'pin.pinterestDetail.edit': 'Edit',
    'pin.pinterestDetail.reconnect': 'Reconnect',
    'pin.pinterestDetail.createPin': 'Create Pin',
    'pin.pinterestDetail.stat.followers': 'Followers',
    'pin.pinterestDetail.stat.following': 'Following',
    'pin.pinterestDetail.stat.pins': 'Pins',
    'pin.pinterestDetail.stat.boards': 'Boards',
    'pin.pinterestDetail.stat.monthlyViews': 'Monthly views',
    'pin.pinterestDetail.tab.boards': 'Boards ({count})',
    'pin.pinterestDetail.tab.pins': 'Pins',
    'pin.pinterestDetail.boards.hint': 'Manage the account boards. Click a board to view its pins.',
    'pin.pinterestDetail.boards.create': 'Create board',
    'pin.pinterestDetail.boards.empty.title': 'No boards yet',
    'pin.pinterestDetail.boards.empty.desc':
      'Click "Create board" above to create your first board.',
    'pin.pinterestDetail.pins.filterByBoard': 'Filter by board:',
    'pin.pinterestDetail.pins.clearFilter': 'Clear filter',
    'pin.pinterestDetail.pins.empty.title': 'No pins yet',
    'pin.pinterestDetail.pins.empty.desc': 'Create the first pin for this account.',
    'pin.pinterestDetail.pins.empty.boardTitle': 'Board "{name}" has no pins',
    'pin.pinterestDetail.pins.empty.boardDesc': 'Create the first pin for this board.',
    'pin.pinterestDetail.pins.loadMore': 'Load more pins',
    'pin.pinterestDetail.pins.allShown': 'All {count} pins shown',
    'pin.pinterestDetail.toast.loadPinsError': 'Failed to load pins.',

    // boardCard
    'pin.boardCard.privacy.public': 'Public',
    'pin.boardCard.privacy.protected': 'Protected',
    'pin.boardCard.privacy.secret': 'Secret',
    'pin.boardCard.noCover': 'No cover image',
    'pin.boardCard.untitled': 'Untitled board',
    'pin.boardCard.pinCount': '{count} pins',
    'pin.boardCard.followerCount': '{count} followers',

    // createBoardModal
    'pin.createBoardModal.title': 'Create Pinterest board',
    'pin.createBoardModal.field.name': 'Board name',
    'pin.createBoardModal.field.description': 'Description',
    'pin.createBoardModal.field.privacy': 'Privacy',
    'pin.createBoardModal.privacy.public': 'Public (PUBLIC)',
    'pin.createBoardModal.privacy.protected': 'Protected (PROTECTED)',
    'pin.createBoardModal.privacy.secret': 'Secret (SECRET)',
    'pin.createBoardModal.cancel': 'Cancel',
    'pin.createBoardModal.create': 'Create',
    'pin.createBoardModal.toast.nameRequired': 'Please enter a board name.',
    'pin.createBoardModal.toast.createSuccess': 'Board created.',
    'pin.createBoardModal.toast.createError': 'Failed to create board.',

    // pinCard
    'pin.pinCard.noImage': 'No image',

    // pinLightbox
    'pin.pinLightbox.attachedLink': 'Attached link',
    'pin.pinLightbox.altText': 'Alt text',
    'pin.pinLightbox.openOnPinterest': 'Open on Pinterest.com',

    // pinterestForm
    'pin.pinterestForm.title.create': 'Create Pinterest account',
    'pin.pinterestForm.title.update': 'Update Pinterest account',
    'pin.pinterestForm.login': 'Sign in with Pinterest',
    'pin.pinterestForm.loginAgain': 'Sign in to Pinterest again',
    'pin.pinterestForm.linkedAccount': 'Pinterest account linked',
    'pin.pinterestForm.create': 'Create',
    'pin.pinterestForm.update': 'Update',
    'pin.pinterestForm.cancel': 'Cancel',
    'pin.pinterestForm.field.name': 'Display name',
    'pin.pinterestForm.field.username': 'Username',
    'pin.pinterestForm.field.businessName': 'Business name',
    'pin.pinterestForm.field.userId': 'User ID',
    'pin.pinterestForm.field.website': 'Website',
    'pin.pinterestForm.field.active': 'Active',
    'pin.pinterestForm.field.namePlaceholder': 'e.g. Main Pinterest Shop',
    'pin.pinterestForm.field.nameHint':
      'An internal label so you can recognize this account — not shown on Pinterest.',
    'pin.pinterestForm.connect.heading': 'Connect your Pinterest account',
    'pin.pinterestForm.connect.desc':
      'Sign in with Pinterest to let the system publish Pins and manage boards on your behalf. Your password is never stored; we only receive a secure authorization code.',
    'pin.pinterestForm.scope.title': 'Check access permissions',
    'pin.pinterestForm.scope.desc':
      'See which permissions the system currently has on this Pinterest account.',
    'pin.pinterestForm.scope.check': 'Check now',
    'pin.pinterestForm.scope.granted': 'Granted',
    'pin.pinterestForm.scope.missing': 'Not granted',
    'pin.pinterestForm.scope.perm.userRead': 'Read account info',
    'pin.pinterestForm.scope.perm.boardsRead': 'View boards',
    'pin.pinterestForm.scope.perm.boardsWrite': 'Create & edit boards',
    'pin.pinterestForm.scope.perm.pinsRead': 'View Pins',
    'pin.pinterestForm.scope.perm.pinsWrite': 'Create Pins',
    'pin.pinterestForm.scope.perm.other': 'Other permission',
    'pin.pinterestForm.scope.missingBoardsWrite':
      'Missing the "Create & edit boards" permission. Click "Sign in to Pinterest again" to re-grant it.',
    'pin.pinterestForm.scope.missingPinsWrite':
      'Missing the "Create Pins" permission. Click "Sign in to Pinterest again" to re-grant it.',
    'pin.pinterestForm.toast.loginDenied': 'Pinterest denied sign-in: {reason}',
    'pin.pinterestForm.toast.invalidState': 'Invalid OAuth state, please sign in again.',
    'pin.pinterestForm.toast.fetchError': 'Failed to fetch Pinterest profile',
    'pin.pinterestForm.toast.missingClientId': 'Missing REACT_APP_PINTEREST_CLIENT_ID config.',
    'pin.pinterestForm.toast.needLogin':
      'You must sign in to Pinterest before creating an account.',
    'pin.pinterestForm.toast.createSuccess': 'Account created.',
    'pin.pinterestForm.toast.createError': 'Failed to create account.',
    'pin.pinterestForm.toast.updateSuccess': 'Account updated.',
    'pin.pinterestForm.toast.updateError': 'Failed to update account.',
    'pin.pinterestForm.toast.checkScopeError': 'Scope check failed.',


    // table
    'pin.table.col.account': 'Account name',
    'pin.table.col.followers': 'Followers',
    'pin.table.col.posts': 'Pins',
    'pin.table.col.url': 'URL',
    'pin.table.col.status': 'Status',
    'pin.table.col.createdAt': 'Created at',
    'pin.table.col.actions': 'Actions',
    'pin.table.copyUrl': 'Copy URL',
    'pin.table.tooltip.viewDetail': 'View details (boards, pins)',
    'pin.table.tooltip.viewDetailShort': 'View details',
    'pin.table.tooltip.createPin': 'Create Pin',
    'pin.table.tooltip.edit': 'Update account',
    'pin.table.tooltip.delete': 'Delete account',
    'pin.table.tooltip.toggleStatus': 'Enable/disable account',
    'pin.table.reconnectHint': 'Session expired — click to reconnect',
    'pin.table.delete.title': 'Delete Pinterest account?',
    'pin.table.delete.desc': 'This action cannot be undone.',
    'pin.table.delete.confirm': 'Delete',
    'pin.table.empty.title': 'No Pinterest accounts yet',
    'pin.table.empty.desc': 'Connect your first Pinterest account to start publishing Pins.',
    'pin.table.empty.action': 'Connect account',
    'pin.table.toast.statusChanged': 'Account status changed',
    'pin.table.toast.statusError': 'Failed to change account status',
    'pin.table.toast.deleteSuccess': 'Account deleted',
  },
};

export default fragment;
